// *****vue-i8n*****
// const cn = {
//     message: {
//         'hello': '你好',
//     }
// }

// export default cn 

// *****兼容element-ui*****
// import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
const cn = {
  message: {
    home:'首页',
    au:'公司介绍',
    serve:'产品&服务',
    port:'团队风采',
    book:'预定',
    pric:'招聘中心',
    contact:'联系我们',
    hello: '你好',
    cancel: '取消',
    confirm: '确定',
    login: '登录',
    click: '点击',
    switchCn: '中文',
    switchEn: '英文(EN)',
    signIn:'伙伴登录',
    slider:'全球整合，全时服务',
    sliderCn:'聚焦航旅，专注服务，为全球客户提供质美价廉的航空票务服务',
    slider2:'智慧启航，驭领未来',
    sliderCn2:'立足自研，与上下游合作伙伴，共赢天下',
    slider3:'和我们一起全球飞翔',
    sliderCn3:'在一起，为梦想，快快乐乐飞',
    welcomeMsg:'和我们一起携手向未来',
    myCompany:'湖南晨飞旅业国际旅行社有限公司，自2013年初春成立以来，已成为民航运输行政主管部门认证的一流客运销售代理企业，专精于国际与国内航线的机票分销。作为行业内的佼佼者，晨飞旅业与众多知名航空公司建立了稳固的合作关系，其中包括南方航空、厦门航空、山东航空、吉祥航空、海南航空、越捷航空、全日空航空等逾三十多家业界翘楚，携手为全球旅客提供便捷、高效的出行解决方案。',
    myCompany2 :'作为携程、去哪儿、飞猪、同程、美团、比客等国内外顶级在线旅游平台的金牌合作伙伴，晨飞旅业凭借卓越的服务品质和专业的行业经验，赢得了市场的广泛赞誉。公司坐落于长沙星沙繁华的新长海广场，占据3栋A座2104室，宽敞明亮的办公空间超过1000平方米，汇聚了一支逾百人的精英团队，共同致力于打造一流的客户体验，引领航旅行业的创新与发展。',
    whyUS:'为什么选择我们？',
    whyUscont:'选择我们，意味着携手一个体制完备、运作高效的团队。我们的架构精炼，国内与国际运营、技术研发及综合管理，各部门并驾齐驱，各司其职，制度健全，权责明确。部门负责人既是舵手也是专家，他们对各自领域深耕细作，直通总经办，确保决策畅通无阻。',
    whyUscont2:'核心管理层犹如定海神针，数载风雨同舟，积淀深厚行业智慧与技术底蕴。我们坚信，创新与执行力是前行的双翼，管理层洞悉市场脉搏，前瞻航空趋势，引领机票代理业革新，持续书写行业标杆篇章。',
    milepost:'公司成立',
    milepost2:'自研系统上线',
    milepost3:'拓展国际业务',
    milepost4:'市占率持续突破',
    milepostCon:'公司是经民航运输行政主管部门批准授权的一类客运销售代理公司，经营国内航线、国际航线的航空客运销售代理业务；国内旅游业务；入境旅游业务；旅游咨询服务；应用软件开发；软件技术转让；信息技术咨询服务。',
    milepostCon2:'在深谙机票行业脉络与动态的坚实基石上，依托雄厚的技术底蕴与创新精神，我们倾力打造了“淘票助手”。这是一套专为国内外机票业务量身定制的全流程智能化管理系统，旨在提升运营效率，以科技之力驱动业务发展。',
    milepostCon3:'凭借着对航空行业的敏锐洞察和卓越的服务品质，赢得了广大客户的信赖与支持。随着全球化浪潮的加速推进，真正的连接不仅局限于本土，更要延伸至全球。正是这份远见与雄心，18年起，我们正式开启了国际机票业务。',
    milepostCon4:'在航空旅行波澜壮阔的时代画卷中，我们书写着一段属于自己的传奇。我们以卓越的客户服务、丰富的航班资源和先进的技术支持，迅速在激烈的竞争中脱颖而出，赢得了广大旅客的青睐与业界的广泛认可。国内国际市场份额持续攀升。',
    Solution:'我们的产品',
    SolutionTit:'订单采集管理系统 ',
    SolutionTit2:'政策自动化投放系统',
    SolutionTit3:'全自动出退改系统',
    SolutionTit4:'智能辅助决策系统',
    SolutionCon:'订单采集系统能够有效地从多个OTA平台实时抓取订单信息，进而为旅行社或票务代理商提供高效、准确的数据支持，优化其业务流程并提升客户体验。',
    SolutionCon2:'政策自动化投放系统能够有效地实现机票政策的自动化管理和投放，进而为航空公司或票务代理机构提供高效、准确的数据支持，优化其业务流程并提升客户体验。',
    SolutionCon3:'全自动出退改系统是一种高度集成的解决方案，旨在通过自动化流程处理来自各个在线OTA平台的机票订单，包括出票、退票和改签等操作。',
    SolutionCon4:'智能辅助决策系统能够实时地收集和分析大量数据，并基于这些数据提供洞察和建议，帮助决策者更好地理解和预测未来的趋势，从而做出更加精准的决策',
    //index end
    productsServe:'我们的产品&服务！',
    productsServeCon:'公司拥有近60人的IT团队，每年投入超过1000万，汇聚行业专业优秀人才，具有持续的技术开发和创新能力，基于JAVA开发出的旅游电子商务服务系统，使得从机票的查询、预订、售后集于一体，服务从质量到速度都得到更好的保证，自动化完成率高达90%，大幅降低了人工成本，且高效准确，年均为旅客提供了超2000万次机票预订服务。是旅游机票行业专业性更强、产品更全面、技术力量更优秀的供应商之一。',
    productsServeCon2:'专注与专业是企业发展的源动力，公司专注于机票行业发展，拥有一批在行业深耕多年的业务运营精英团队，同时自主研发了充分体现行业特征的旅游电子商务平台，多年的积累和不懈努力使产品功能不断丰富，公司产品主要包括:订单采集管理系统、政策自动化投放系统、全自动出退改系统、智能辅助决策系统等等。',
    productsTit:'订单采集管理系统',
    productsTit2:'政策自动化投放系统',
    productsTit3:'全自动出退改系统',
    productsTit4:'智能辅助决策系统',
    productsCon:'系统已对接目前市面上几乎所有OTA平台的出退改机票订单及其配套接口，实现了ALL-IN-ONE的业务处理模式和更优更高效率的业务处理流程。',
    productsCon2:'系统能够有效支撑机票政策的自动化管理，包括政策数据采集、加工处理，包装投放及智能调控，同时很好适应各OTA平台多样化的政策投放模式。',
    productsCon3:'全自动出退改系统是一套高度集成的自动化整体解决方案，旨在大幅提高机票运营各环节的全自动化水平，降本增效，支撑业务量持续稳定增长。',
    productsCon4:'智能辅助决策系统能够实时地收集和处理大量数据，通过大数据分析，帮助决策者，智能化系统更好地理解调控和预测未来，从而做出更精准的决策。',
    //services end
    //teamStyle
    portTit:'我们年轻充满活力',
    portCon:'欢迎来到我们的团队——一个充满活力与创造力的大家庭！年轻的心，无限的可能 我们是一支由一群年轻人组成的团队，平均年龄只有28岁。我们拥有着对世界的好奇心和探索欲，不断学习新知识，拥抱变化。年轻的心态让我们敢于尝试不同的方法解决问题，勇于接受挑战。活力四射，激情满满 我们的团队充满着活力与激情。每一天都充满了新鲜感，无论是项目讨论还是日常交流，总能感受到一股积极向上的力量。',
    portcon2:'友善相处，温暖如家 我们相信一个友好的环境能够激发更多的创意和灵感。在这里，每个人都是团队的一份子，我们彼此尊重，相互支持。无论是工作上的难题还是生活中的困扰，我们都乐于伸出援手，共同面对。团结协作，共创辉煌 团结就是力量。我们深知团队合作的重要性，每个人都愿意为了共同的目标贡献自己的力量。无论遇到什么困难，我们都会齐心协力，找到最佳解决方案。这种强大的凝聚力是我们取得成功的关键。积极向上，永不止步 我们始终保持着积极向上的心态，即使面临挫折也不轻言放弃',
    tab:'我们是一群朝气蓬勃的少年',
    //teamStyle end

    //recruitment
    pricTit:' 加入我们，共创未来！',
    pricCon:'亲爱的探索者，在这个不断进化的世界里，我们一直在寻找那些不仅有梦想，而且有勇气去实现它们的人。我们相信，每一个伟大的成就都始于一个小小的火花——那就是激情。如果你对创新充满热情，渴望在一个充满活力和挑战的环境中成长，那么，欢迎来到我们的团队！',
    pricCon2:'我们致力于通过技术和眼光结合行业特点，开发充分体现行业特征的旅游电子商务平台，推动行业向前发展。我们的愿景是创造一个更加智能、更加便捷的旅行服务平台。我们相信，只有当我们的产品和服务真正触及到每个人的心灵，才能称之为成功。',
    RecruitingPlan:'招聘计划',
    pricBase:'数据采集工程师',
    pricBase2:'开发工程师',
    pricBase3:'产品经理',
    pricBase4:'机票运营专员',
    pricxz:'薪资 ￥10000-20000',
    pricxz2:'薪资 ￥8000-15000',
    pricxz3:'薪资 ￥8000-15000',
    pricxz4:'薪资 ￥5000-8000',
    pricRespontit:'岗位职责',
    pricResponsitit:'任职要求',
    pricResponCon:'1.参与分布式数据采集系统的设计与开发，核心模块研发工作，改进和提升数据采集效率<br>2.攻破各种数据采集策略，快速解决各类技术疑难问题，建设数据采集对抗组件库<br>3.负责网页信息和APP数据抽取、清洗、消重等工作,实时监控采集进度和预警处理<br>4.与产品部门和上级沟通确保数据的准确性及时性,负责采集指定网站和APP的数据<br>5.及时响应业务需求进行开发',
    pricResponsibility:'1、2年以上数据采集经验，有电商行业网站数据采集经验优先<br>2、熟悉python/java语言，具备扎实的编程功底，具有良好的程序设计能力<br>3、熟悉行为验证码识别、模拟登陆、数据清洗、去重、入库等<br>4、熟悉编写网络数据采集规则，对数据采集、加解密、代理、模板、app破壳等技术有所理解<br>5、了解JS反混淆，对反混淆有一定实践经验<br>6、有app采集经验，熟练使用xposed、frida、ida、gdb等逆向分析工具<br>7、本科以上学历计算机相关专业优先考虑',
    pricResponCon2:'1、根据产品需求，负责功能模块设计，编码及单元测试，按时保质保量完成任务<br>2、系统开发基础资源框架的不断升级完善及组件积累<br>3、系统日常维护，优化改进，确保已上线系统运行稳定可靠<br>4、领导交办的其他工作',
    pricResponsibility2:'1、软件工程或计算机相关专业本科或以上学历，3年以上JAVA软件开发工作经验<br>2、熟悉主流J2EE开发框架，熟练使用Spring/Spring Boot/Spring Cloud/Hibernate/MyBatis/Struts等开发框架，具有扎实的Java基本功底和良好的编程习惯<br>3、熟悉Web及前端技术（包括Javascript，Ajax，jQuery,EasyUI,Vue等开源框架）<br>4、熟悉基于Oracle、MySql数据库的软件设计、开发，熟练编写SQL查询、存储过程等<br>5、熟悉常见的Linux命令，能够独立配置基于Linux的Java应用的运行环境：Nginx/Apache、Jdk、Redis、RocketMq<br>6、熟悉Weblogic、Tomcat等Web容器产品的配置',
    pricResponCon3:'1、负责分析现有产品问题，梳理改进方案<br>2、理解用户，系统性挖掘用户需求，完成创新性产品设计<br>3、定期进行竞品对比，分析竞品背后的思路和逻辑<br>4、在完整产品生命周期中独立跟进项目，确保产品高质量产出，并规划项目节奏，持续迭代产品。',
    pricResponsibility3:'1.3年及以上民航票务行业工作经验，熟悉国际国内航司产品<br>2. 对互联网行业，线上旅游平台(OTA)的有深度了解，愿意学习新知识，接受新挑战，肯吃苦<br>3.具有团队合作精神及抗压性，能够协调各部门处理并解决问题<br>4. 具备创新意识，能够发现处理流程的问题并提出自己的解决方案。',
    pricResponCon4:'1、通过系统平台操作机票报价、预订、出票及退票改签等业务<br>2、了解各航司和各平台的规则出退改签时限要求，根据订单对应渠道操作相应的出退改业务<br>3、责任心强，具备良好职业素养和服务意识',
    pricResponsibility4:'1、性别不限，可接受无机票工作经验者，一对一老带新<br>2、学习主动积极，抗压能力强；能吃苦耐劳，有责任心<br>3、接受应届毕业生<br>4、学习能力强，有较强的主动性、上进心、责任心，有耐心，共情能力强，英语好的话锦上添花<br>5、善于沟通，具有良好的客户服务意识和业务拓展能力<br>6、能承受一定工作压力，愿意接受高薪挑战<br>7、会简单的电脑操作（简单代码修改）',
    //recruitment end
    //contact us
    contactTit:'联系我们',
    contactCon:'我们非常荣幸能在这个美好的时刻与您相遇！无论是初次访问还是再次光临，我们都衷心欢迎您的到来。在这里，我们致力于为我们的客户、合作伙伴提供最优质的服务和体验，让每一次的互动都充满温暖和喜悦。我们始终坚持以需求为导向，不断追求卓越。我们相信，每一次的成功都离不开每一位客户、伙伴的信任和支持。因此，我们诚挚地邀请您参与我们的旅程，一起探索无限可能。',
    contactCon2:'我们是一个充满活力与创新精神的团队，如果您有任何问题、建议或合作意向，请随时与我们取得联系。期待与您的每一次交流！',
    contactTextName:'姓名',
    contactTextEmail:'邮箱',
    contactTextSubject:'主题',
    contactTextMessage:'内容',
    contactSubmit:'发送',
    tostName:'姓名不能为空',
    tostEmail:'请填写正确的邮箱地址',
    tostSubject:'主题不能为空',
    tostMessage:'内容不能为空',
    //contact us end
    success:'您的信息已收到，我们会在第一时间与您联系，感谢您的关注。',
    error:'非常抱歉，您的信息发送遇到错误，您可拨打页面左下角电话或发送邮件与我们取得联系。',
    //footer'
    doheadLink:'We are team awlesome',
    //footer
    gsquot:'创新',
    gsquotcont:'以现有的思维模式提出有别于常规或常人思路的见解为导向，利用现有的知识和物质，在特定的环境中，本着理想化需要或为满足公司需求，而改进或创造新的事物，包括但不限于各种产品、方法、元素、环境等等，并能获得一定有益效果的行为。',
    gsquot2:'进取',
    gsquotcont2:'积极主动地向前推进，努力进取，不甘于现状。对事业、学习、生活等方面充满进取心和积极性的状态。它可以用来鼓励自己或他人在面对困难时保持积极的态度。',
    gsquot3:'合作',
    gsquotcont3:'是个人与个人、群体与群体之间为达到共同目的，彼此相互配合的一种联合行动、方式。',
    gsquot4:'团结',
    gsquotcont4:'团结是由多种情感聚集在一起而产生的一种精神。团结就是相互配合，真正的团结就是无条件的配合。团结并不只存在于志同道合中。想要成为一个团结优秀的集体，只需要我们都用真诚去面对集体中的每一个人，让这个集体里的每一个人，都感觉到心灵的温暖。',
    widgetCn:'联系方式',
    addr:'公司地址',
    addrcon:'长沙经济技术开发区泉塘街道板仓南路29号和向阳路10号新长海中心服务外包基地3栋A座2104',
    fixedTelephone:'0731-84873575',
    domestic:'合作伙伴',
    domesticOta:"OTA平台",
    domesticAir:"航空公司",
    international:'合作伙伴(国际航司)',
    platform:'合作伙伴(OTA平台)',
    flinkCon:'中国国际航空',
    flinkCon2:'中国东方航空',
    flinkCon3:'中国南方航空',
    flinkCon4:'海南航空',
    flinkCon5:'成都航空',
    flinkCon6:'‌浙江长龙航空',
    flinkCon7:'越捷航空公司',
    flinkCon8:'大韩航空公司',
    flinkCon9:'全日空航空公司',
    flinkCon10:'‌香港快运航空公司',
    flinkCon11:'韩亚航空公司',
    flinkCon12:'美国联合航空公司',
    flinkCon13:'携程旅行',
    flinkCon14:'去哪儿旅行',
    flinkCon15:'同程旅行',
    flinkCon16:'飞猪旅行',
    flinkCon17:'美团',
    flinkCon18:'比客',
  },
}

export default cn;



// WEBPACK FOOTER //
// ./src/i18n/langs/cn.js